<div [@routerTransition] class="height-100pe">
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="row height-100pe">
    <div class="col-md-12">
      <div class="card my-profile-form margin-top-15px top-link">
        <div class="card-header wh-header padding-bottom-6px">
          <div class="row">
            <div class="col-md-12">
              Lab Orders &amp; Tests
            </div>

          </div>
          <div class="row">
            <div class="col-md-12 padding-right-0px">
              <div class="row">
                <div class="max-width-6pe col-sm-3 padding-right padding-left-0px text-align-right margin-top-3px margin-left-4px">
                  <label class="margin-right-3px margin-bottom-0px font-size-16px">Branch :</label>
                </div>
                <div class="max-width-9pe padding-left-0px">
                  <div class="form-group margin-bottom-0px">
                    <CustomDataByRequestType RequestedType="FacilityList" ActorCode={{ActorCode}}
                                             (keyChange)="Branchdata($event)"
                                             [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode" SelectedValue="SelectedFacilityCode"
                                             required>
                    </CustomDataByRequestType>
                    <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                    [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                    name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->
                    <!--<h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">4116</h4>-->


                  </div>
                </div>
                <div class="max-width-7pe col-sm-3 padding-right padding-left-0px text-align-right">
                  <label class="margin-right-10px margin-bottom-0px font-size-16px">
                    <input type="radio" class="margin-right-3px" [(ngModel)]="Selectedtoday" name="sameName" id="nameA" value="nameA" (change)="onSubmit2($event)"> Today
                  </label>
                </div>
                <div class="max-width-9pe padding-left-0px">
                  <div class=" margin-bottom-0px font-size-16px margin-top-3px">

                    <input type="radio" class="margin-right-3px" [(ngModel)]="SelectedDuration" name="sameName" id="nameB" value="nameB" (change)="onSubmit($event)"> Duration


                  </div>
                </div>
                <div class="max-width-5pe col-sm-3 padding-right padding-left-0px text-align-right margin-top-3px" *ngIf="isdisplaydate">
                  <label class="margin-right-3px margin-bottom-0px font-size-16px">From :</label>
                </div>
                <div class="max-width-9pe padding-left-0px" *ngIf="isdisplaydate">
                  <div class="date-form">
                    <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                           name="SelectedFrom" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                           (ngModelChange)="dataChanged($event)">

                    <a (click)="d.toggle()" class="nav-link-hand">
                      <span class="date-icon margin-top-3px"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>
                </div>
                <div class="max-width-4pe col-sm-3 padding-right padding-left-0px text-align-right margin-top-3px" *ngIf="isdisplaydate">
                  <label class="margin-right-3px margin-bottom-0px font-size-16px">To :</label>
                </div>
                <div class="max-width-9pe padding-left-0px" *ngIf="isdisplaydate">
                  <div class="date-form">
                    <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new" placeholder="To Date" [minDate]="minDate" [maxDate]="maxDate"
                           name="SelectedTo" [(ngModel)]="SelectedToDate" ngbDatepicker #d1="ngbDatepicker"
                           (ngModelChange)="dataChanged($event)">

                    <a (click)="d1.toggle()" class="nav-link-hand">
                      <span class="date-icon margin-top-3px"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>
                </div>
                <div class="max-width-9pe col-sm-3 padding-right padding-left-0px text-align-right margin-top-3px">
                  <label class="margin-right-3px margin-bottom-0px font-size-16px">Department :</label>
                </div>
                <div class="max-width-9pe padding-left-0px">
                  <div class="form-group margin-bottom-0px">
                    <CustomDataByRequestType RequestedType="AccessibleDepartments" ActorCode={{ActorCode}}
                                             (keyChange)="DepData($event)"
                                             [(ngModel)]="SelectedDepCode" name="SelectedDepCode" SelectedValue="SelectedDepCode"
                                             required>
                    </CustomDataByRequestType>
                    <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                    [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                    name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->
                    <!--<h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">4116</h4>-->


                  </div>
                </div>



                <!--<div class="col-md-3 float-right padding-right-0px padding-l-0px display-inherit">
                  <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>

                </div>-->
                <div class="max-width-12pe padding-left-0px">
                  <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-10px" (click)="Go()">Go</button>
                  <!--<button class="btn font-size-13px actions-btn-prime  margin-left-5px" title="print" (click)="printexpenses()">GetReport</button>-->
                </div>
                <div class="max-width-18pe padding-left-0px margin-left-10px margin-right-3px display-inherit">
                  <form novalidate="" #f="ngForm" class="display-inherit">
                    <div class="clear-form">
                      <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
                      <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
                    </div>
                    <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
                  </form>
                  <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->
                </div>
                <!--<div class="max-width-12pe padding-left-0px">
                  <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-10px" (click)="LoadForms()">Go</button>
                  <button class="btn font-size-13px actions-btn-prime  margin-left-5px" title="print" (click)="printexpenses()">GetReport</button>
                </div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="card-body padding-top-0px margin-left-0px">
          <!--<div class="row">
            <div class="offset-md-10 col-md-2">
              <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
            </div>
          </div>-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-zero width-100pe"
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>

                        <th class="min-width-24px padding-top-4px padding-bottom-4px">
                          #
                        </th>
                        <!--<th class="text-align-center">Day</th>-->
                        <!--<th class="text-align-center">
                          Old Reg No
                        </th>-->
                        <th class="padding-top-4px padding-bottom-4px">
                          Date
                        </th>
                        <th class="padding-top-4px padding-bottom-4px">Order</th>
                        <th class="padding-top-4px padding-bottom-4px">
                          Patient
                        </th>

                        <!--<th class="">
                          Prime Relation
                        </th>-->

                        <th class="padding-top-4px padding-bottom-4px">
                          Sex
                        </th>
                        <th class="padding-top-4px padding-bottom-4px padding-right-5px">
                          Age
                        </th>
                        <th class="padding-top-4px padding-bottom-4px">
                          Has Specimen
                        </th>
                        <th class="padding-top-4px padding-bottom-4px">
                          Test
                        </th>
                        <th class="padding-top-4px padding-bottom-4px">
                          Specimen Status
                        </th>

                        <th class="padding-top-4px padding-bottom-4px">
                          Results Status
                        </th>

                        <!--<th class="padding-top-4px padding-bottom-4px">
                          Signature Status
                        </th>-->
                        <th></th>

                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentLabOrderRequestsController ; let RowIndex = index ">

                        <td class="td-padding-tb">{{RowIndex+1}}</td>


                        <td class=" td-padding-tb">{{l.OrderDate| date:'MMM-dd-yyyy'}}</td>


                        <td class=" td-padding-tb">
                          {{l.OrderCode}}
                        </td>



                        <td class="td-padding-tb">{{l.PatientName}}</td>

                        <td class="td-padding-tb  padding-right-0px">{{l.Gender}}</td>
                        <td class="td-padding-tb  ">{{l.AgeInYears}}</td>
                        <td class="td-padding-tb  text-align-center padding-left-0px">
                          <!--<label class="switch">
                            <input type="checkbox"
                                   [(ngModel)]="l.IsSpecimenAssociated">
                            <span class="slider round"></span>
                          </label>-->
                          <i class="fa fa-check float-none tick-mark-styles" *ngIf="l.IsSpecimenAssociated"></i>
                        </td>
                        <td class="td-padding-tb ">{{l.LabTestName}}</td>
                        <td class="td-padding-tb ">
                          <a (click)="Specimen2(l)" data-toggle="tooltip" class="cursor" data-placement="bottom" title="Click Here Goto Specimencollection" *ngIf="l.SpecimenCollectionStatus=='Collected'">

                            <i class="fas fa-circle color-green  nav-link-hand font-size-14">
                            </i> Collected
                          </a>
                          <a (click)="Specimen2(l)" data-toggle="tooltip" class="cursor" data-placement="bottom" title="Click Here Goto Specimencollection" *ngIf="l.SpecimenCollectionStatus=='Pending'">

                            <i class="fas fa-circle color-Assign  nav-link-hand font-size-14">
                            </i> Pending
                          </a>

                        </td>

                        <td class="td-padding-tb ">
                          <a (click)="Resultsentry(l)" data-toggle="tooltip" class="cursor" data-placement="bottom" title="Click Here Goto ResultsEntry" *ngIf="l.OrderTestStatus=='Results Entered'">

                            <i class="fas fa-circle color-green  nav-link-hand font-size-14">
                            </i> Resutls Entered
                          </a>
                          <a (click)="Resultsentry(l)" data-toggle="tooltip" class="cursor" data-placement="bottom" title="Click Here Goto ResultsEntry" *ngIf="l.OrderTestStatus=='Results Pending'">

                            <i class="fas fa-circle color-Assign  nav-link-hand font-size-14">
                            </i> Results Pending
                          </a>
                          <a (click)="Resultsentry(l)" data-toggle="tooltip" class="cursor" data-placement="bottom" title="Click Here Goto ResultsEntry"
                             *ngIf="l.OrderTestStatus=='Signed' || l.OrderTestStatus=='Signed '">

                            <i class="fa fa-check color-green  nav-link-hand font-size-14">
                            </i> Signed
                          </a>
                          <a (click)="Resultsentry(l)" data-toggle="tooltip" class="cursor" data-placement="bottom" title="Click Here Goto ResultsEntry" *ngIf="l.OrderTestStatus=='Signed (1)'">


                            <i class="fa fa-check color-gray  nav-link-hand font-size-14">
                            </i>Signed (1)
                          </a>
                          <a (click)="Resultsentry(l)" data-toggle="tooltip" class="cursor" data-placement="bottom" title="Click Here Goto ResultsEntry" *ngIf="l.OrderTestStatus=='Signed (2)'">


                            <i class="fa fa-check color-green  nav-link-hand font-size-14">
                            </i>Signed (2)



                          </a>
                        </td>
                        <td>
                          <div *canUserAccess="['DeleteLabOrder']">
                            <a class="nav-link-hand font-size-12px color-Rejected" title="Remove" (click)="DeleteLabOrder(l)">
                              <i class="far fa-trash-alt nav-link-hand"></i>
                            </a>
                          </div>
                        </td>
                        <!--<td class="td-padding-tb ">

                          <a data-toggle="tooltip" data-placement="bottom" title="Signed" *ngIf="l.OrderTestStatus=='Signed'">

                            <i class="fas fa-circle color-green  nav-link-hand font-size-14">
                            </i> Signed
                          </a>
                          <a data-toggle="tooltip" data-placement="bottom" title="Pending" *ngIf="l.OrderTestStatus=='Sign1'">

                            <i class="fas fa-circle color-Assign  nav-link-hand font-size-14">
                            </i> Pending
                          </a>
                        </td>-->


                      </tr>
                      <!--<tr>

                        <td class="td-padding-tb">GGH0</td>


                        <td class=" td-padding-tb">19</td>


                        <td class=" td-padding-tb">
                         Sham
                        </td>



                        <td class="td-padding-tb">one</td>

                        <td class="td-padding-tb  text-align-center padding-right-0px">100</td>
                        <td class="td-padding-tb  ">cash</td>
                        <td class="td-padding-tb  ">hari</td>
                        <td class="td-padding-tb ">service</td>
                        <td class="td-padding-tb ">
                          <button type="button" (click)="ViewItem()" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime-man actions-btn-prime3 margin-left-auto font-size-13px padding-left-5px padding-right-5px min-width-32px">
                            <i class="fa fa-ellipsis-h"></i>
                          </button>
                          <button class="btn font-size-13px actions-btn-prime  margin-left-5px">Cancel Voucher</button>

                        </td>





                      </tr>-->
                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>


</div>


